<template>
  <div class="bg">
    <v-overlay
      :value="true"
      opacity="0.7"
      color="black"
    >
      <div>
        sdasda
      </div>
    </v-overlay>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
body, html{
  height: 100vh;

}
.bg{
    height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../assets/DSC08717.jpg");

}

</style>